import { useQuery } from "react-query";
import API from "@Config/axios";
import { QUERY_KEY } from "@Constants/query-keys";

const fetchQueueById = async (queueId) => {
  const { data } = await API.get(`/queues/${queueId}`);
  return data;
};

const useGetQueueById = (queueId) => {
  return useQuery(
    [QUERY_KEY.GET_QUEUE, queueId],
    () => fetchQueueById(queueId),
    {
      enabled: !!queueId,
      keepPreviousData: false,
      refetchOnWindowFocus: false
    }
  );
};

export default useGetQueueById;
